import { h } from 'preact';
import PropTypes from 'prop-types';

import { getLabel } from '../../../../labels/labelling-service';
import Cta from '../../2-atoms/cta/cta';

const CLASSNAME = 'c-sky-it-confirm';

const SkyItConfirm = ({ onConfirm, onCancel, ctaPrimaryLabel, message, selectedItems, totalItems }) => {
  if (!onConfirm) {
    return;
  }

  const classNames = message ? `${CLASSNAME} ${CLASSNAME}--with-message` : CLASSNAME;
  const formattedMessage = message ? message.replace('%s', `<b>(${selectedItems}/${totalItems})</b>`) : message;

  return (
    <div className={classNames}>
      <Cta tag="button" modifiers={['sky-it-primary']} onClick={onConfirm}>
        {ctaPrimaryLabel || getLabel('global.confirm')}
      </Cta>
      <div className="c-sky-it-confirm__footer">
        <Cta tag="button" modifiers={['sky-it-no-outline', 'capitalized']} onClick={onCancel}>
          {getLabel('global.cancel')}
        </Cta>
        {message && <p className="c-sky-it-confirm__message" dangerouslySetInnerHTML={{ __html: formattedMessage }} />}
      </div>
    </div>
  );
};

SkyItConfirm.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  ctaPrimaryLabel: PropTypes.string,
  message: PropTypes.string,
  selectedItems: PropTypes.number,
  totalItems: PropTypes.number,
};

export default SkyItConfirm;
